import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import PropTypes from 'prop-types'
import { IconButton, Typography } from '@material-ui/core'
import IconBack from '@material-ui/icons/ArrowBack'
import {
  licenseeApplicationFetchFormData,
  licenseeApplicationClearStateForm,
  licenseeApplicationChange,
} from 'reducers/licenseeApplication/reducer'
import { fetchProfile } from 'reducers/profile/reducer'
import LicenseeApplicationCreateForm from 'components/licenseeApplication/LicenseeApplicationCreateForm'
import withPromise from 'helpers/withPromise'
import Loader from 'components/Loading'
import { REACT_INTL_PROP_TYPE } from 'constants/propTypes'
import messages from './translate'

class LicenseeApplicationItem extends Component {
  componentDidMount() {
    const { licenseeApplicationFetchFormData } = this.props

    licenseeApplicationFetchFormData({
      entityId: this.getEntityId(),
    })
  }

  componentWillUnmount() {
    const { licenseeApplicationClearStateForm } = this.props

    licenseeApplicationClearStateForm()
  }

  getEntityId() {
    const {
      match: {
        params: { id },
      },
    } = this.props

    return id !== 'create' ? id : 0
  }

  onSubmit = values => {
    const {
      licenseeApplicationChange,
      fetchProfile,
      history: { goBack },
    } = this.props
    // eslint-disable-next-line no-param-reassign
    values.orderNumber = values.orderNumber
      ? parseInt(values.orderNumber, 10)
      : 0
    const formatValues = { ...values }

    return withPromise(licenseeApplicationChange, {
      entityId: this.getEntityId(),
      values: formatValues,
    })
      .then(errors => (errors ? Promise.resolve(errors) : goBack()))
      .then(() => {
        fetchProfile()
      })
  }

  render() {
    const {
      isLoadForm,
      formData,
      intl: { formatMessage },
      history: { goBack },
    } = this.props

    if (isLoadForm) {
      return <Loader pastDelay />
    }

    return (
      <div className="container-fluid no-breadcrumb">
        <Typography variant="h5" className="headline">
          <IconButton size="medium" className="btn-back" onClick={goBack}>
            <IconBack fontSize="small" />
          </IconButton>
          {formatMessage(messages.licenseeApplication)}
        </Typography>
        <LicenseeApplicationCreateForm
          formData={formData}
          onSubmit={this.onSubmit}
        />
      </div>
    )
  }
}

LicenseeApplicationItem.propTypes = {
  intl: REACT_INTL_PROP_TYPE.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func,
  }).isRequired,
  formData: PropTypes.object.isRequired,
  isLoadForm: PropTypes.bool.isRequired,
  licenseeApplicationFetchFormData: PropTypes.func,
  licenseeApplicationClearStateForm: PropTypes.func,
  licenseeApplicationChange: PropTypes.func,
  fetchProfile: PropTypes.func,
}

LicenseeApplicationItem.defaultProps = {
  licenseeApplicationFetchFormData: () => {},
  licenseeApplicationClearStateForm: () => {},
  licenseeApplicationChange: () => {},
  fetchProfile: () => {},
}

export default connect(
  state => ({
    isLoadForm: state.getIn(['licenseeApplication', 'isLoadForm']),
    formData: state.getIn(['licenseeApplication', 'formData']).toJS(),
  }),
  {
    licenseeApplicationFetchFormData,
    licenseeApplicationClearStateForm,
    licenseeApplicationChange,
    fetchProfile,
  },
)(injectIntl(LicenseeApplicationItem))
